export const EndUserProfilesInfo = () => (
  <>
    <p>An end-user profile contains data (name address) and documents.</p>
    <p>The required data and documents vary per Country and Plan.</p>
    <p>
      In the following step you can add this data and documents and crosscheck
      with the requirements of the Country and Plan.{' '}
    </p>
    <p>
      When ordering DIDs, you will able to use incomplete end-user profiles but
      you will have to complete these (via End user profiles) within 48 hours
      after submitting the order.
    </p>
  </>
);
